import {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
} from "react";
import { GameKeys, GamesAPI, GamesData } from "../Games";
import { AllGamesData } from "../GamesDatas";
import { useGamesReducer } from "./GamesReducer";

//  CONTEXTS
const GamesAPIContext = createContext<GamesAPI>({} as GamesAPI);
const GamesDataContext = createContext<GamesData>({} as GamesData);

export const GamesProvider: FC<PropsWithChildren> = ({ children }) => {
  console.info("GamesContext render");

  //  DATA REDUCER
  const { data, dispatch } = useGamesReducer();

  //  API
  const api = useMemo<GamesAPI>(() => {
    const openGame = (id: GameKeys) => {
      dispatch({ type: "open", id });
    };

    const closeGame = () => {
      dispatch({ type: "close" });
    };

    const checkGameId = (id: GameKeys) => {
      return AllGamesData.find((game) => game.id === id) !== null;
    };

    const setProgress = (progress: number) => {
      dispatch({ type: "updateProgress", progress });
    };

    const validateGame = () => {
      dispatch({ type: "validate" });
    };

    const unloadGame = () => {
      dispatch({ type: "unloadGamae" });
    };

    return {
      openGame,
      closeGame,
      checkGameId,
      validateGame,
      setProgress,
      unloadGame,
    };
  }, [dispatch]);

  return (
    <GamesAPIContext.Provider value={api}>
      <GamesDataContext.Provider value={data}>
        {children}
      </GamesDataContext.Provider>
    </GamesAPIContext.Provider>
  );
};

//  CUSTOM HOOKS
export const useGamesAPI = () => useContext(GamesAPIContext);
export const useGamesData = () => useContext(GamesDataContext);
